import React, { PropsWithChildren } from 'react'
import './index.scss'
import clsx from 'clsx'

interface HelpWorkRegistrationCardProps {}

const HelpWorkRegistrationCard = ({ children }: PropsWithChildren<HelpWorkRegistrationCardProps>) => {
    const [isHidden, setIsHidden] = React.useState<boolean>(false)

    const hideFunc = () => {
        setIsHidden(!isHidden)
    }

    return (
        <div className={clsx('help-card-component', isHidden && 'hidden')}>
            <div className="head">
                <span className="small bold">Help content</span>
                <span className="small bold hide" onClick={hideFunc}>
                    {isHidden ? 'Show' : 'Hide'}
                </span>
            </div>
            <div className="content"> {children}</div>
        </div>
    )
}

export default HelpWorkRegistrationCard
